module.exports = __webpack_public_path__ + "img/appBarFinish.d0099553.png";